<div *ngIf="configurationList?.length > 1" class="search-switch-configuration">
  <h3 id="configuration-switch">{{ 'search.switch-configuration.title' | translate}}</h3>

  <select class="form-control"
          aria-labelledby="configuration-switch"
          [compareWith]="compare"
          [(ngModel)]="selectedOption"
          (change)="onSelect()">
    <option *ngFor="let option of configurationList;" [attr.data-test]="option.value" [ngValue]="option">
      {{option.label | translate}}
    </option>
  </select>

</div>
